import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, Events, ModalController } from 'ionic-angular';
import { Storage } from '@ionic/storage';

import { User } from '../../models/user.model';
import { AuthProvider } from '../../providers/auth/auth';
import { NotificationProvider } from '../../providers/notification/notification';

import { ProfileAvatarPage } from '../profile-avatar/profile-avatar';
import { ProfileEditPage } from '../profile-edit/profile-edit';
import { LoginPage } from '../auth/login';
import { PrivacyPolicyPage } from '../privacy-policy/privacy-policy';
import { TermsOfUsePage } from '../terms-of-use/terms-of-use';

import { fadeInOutAnimation } from '../../animations/fade-in-out';
import { RankProgressPage } from '../rank-progress/rank-progress';

@IonicPage()
@Component({
  selector: 'page-profile',
  templateUrl: 'profile.html',
  animations: [
    fadeInOutAnimation
  ]
})
export class ProfilePage {

  user: User;
  err: string;
  loading: boolean;

  constructor(public storage: Storage, public navCtrl: NavController, public navParams: NavParams, public events: Events, public modalCtrl: ModalController, public authProvider: AuthProvider, public notificationProvider: NotificationProvider) {}

  private getProfile() {
    this.loading = true;
    this.authProvider.profile()
      .subscribe(
        user => this.user = new User(user),
        error => {
          this.err = <any>error;
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
  }

  openRankProgress() {
    this.storage.get('current_brand').then((brand) => {
      let rankProgressModal = this.modalCtrl.create(RankProgressPage, { showBackBtn: true, user: this.user }, { cssClass: brand.name });
      rankProgressModal.present();
    });
  }

  language() {
    this.events.publish('language:open');
  }

  edit() {
    this.navCtrl.push(ProfileEditPage);
  }

  logout() {
    this.storage.set('basket', new Array());
    this.authProvider.logout();
    this.notificationProvider.clear();
    this.navCtrl.setRoot(LoginPage);
  }

  openProfileAvatar() {
    this.navCtrl.push(ProfileAvatarPage);
  }

  openPrivacyPolicy() {
    this.navCtrl.push(PrivacyPolicyPage);
  }

  openTermsOfUse() {
    this.navCtrl.push(TermsOfUsePage);
  }

  ionViewWillEnter() {
    this.getProfile();
  }

}



// WEBPACK FOOTER //
// ./src/pages/profile/profile.ts